import MyLearningView from "../../features/learning/MyLearningView";

const MyLearningPage = () => <MyLearningView />;

export default MyLearningPage;
